import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { UploadTaskSnapshot } from '@angular/fire/storage/interfaces';
import { Image } from '@fitscovery/common/types';
import { AbstractImageService } from './image.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FirebaseStorageService extends AbstractImageService {

	private percentage: Observable<number>;
	private snapshot: Observable<any>;
	private task: AngularFireUploadTask;
	private uploadRef: any;

	constructor(
		private storage: AngularFireStorage
	) {
    super();
  }

  getSasToken(token?: string): Observable<string> {
    throw new Error('Method not implemented.');
  }

	uploadImage(image: Image, userId: string, folderInContainer?: string): Observable<UploadTaskSnapshot> {
		return this.upload(image, folderInContainer!, userId);
	}

	private upload(image: Image, folder: string, userId: string): Observable<UploadTaskSnapshot> {
		const filePath = `${folder}/${userId}/${new Date().getTime()}_${image.file.name}`;
		this.uploadRef = this.storage.ref(filePath);

		const blob: Blob = this.b64toBlob(image.base64, image.file.type);
		this.task = this.storage.upload(filePath, blob, { contentType: image.file.type });

		this.percentage = this.task.percentageChanges() as any;
		this.snapshot = this.task.snapshotChanges();

		return this.task.snapshotChanges() as any;
	}

  
  b64toBlob(b64Data: any, contentType = '', sliceSize = 512) {
    b64Data = this.trimb64(b64Data);
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getFileType(fileType: any) {
    return fileType.split('/')[1];
  }

  trimb64(b64Data: any): string {
    return b64Data.split(',')[1];
  }

}
